import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import { formatScore } from "../utils/formatting";
import { calculateResults } from "../utils/trainingResultsCalculations";

const DailySummary = ({ dailyTransactions }) => {
  const { upperBody, lowerBody, cardio } = calculateResults(dailyTransactions);
  return (
    <Box>
      <Grid container spacing={2}>
        {/* 上半身 */}
        <Grid size={{ xs: 6 }} display={"flex"}>
          <Card
            sx={{ bgcolor: (theme) => theme.palette.grey[100], flexGrow: 1 }}
          >
            <CardContent>
              <Typography
                variant="body2"
                noWrap
                sx={{
                  textAlign: "center",
                }}
              >
                上半身
              </Typography>
              <Typography
                sx={{
                  fontWeight: "fontWeightBold",
                  textAlign: "right",
                  wordBreak: "break-all",
                  color: (theme) => theme.palette.upperBody.dark,
                }}
              >
                {formatScore(upperBody)}pt
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        {/* 下半身 */}
        <Grid size={{ xs: 6 }} display={"flex"}>
          <Card
            sx={{ bgcolor: (theme) => theme.palette.grey[100], flexGrow: 1 }}
          >
            <CardContent>
              <Typography variant="body2" noWrap sx={{ textAlign: "right" }}>
                下半身
              </Typography>
              <Typography
                sx={{
                  fontWeight: "fontWeightBold",
                  textAlign: "right",
                  wordBreak: "break-all",
                  color: (theme) => theme.palette.expenseColor.dark,
                }}
              >
                {formatScore(lowerBody)}pt
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        {/* 有酸素運動 */}
        <Grid size={{ xs: 12 }} display={"flex"}>
          <Card
            sx={{ bgcolor: (theme) => theme.palette.grey[100], flexGrow: 1 }}
          >
            <CardContent>
              <Typography variant="body2" noWrap sx={{ textAlign: "center" }}>
                有酸素運動
              </Typography>
              <Typography
                sx={{
                  fontWeight: "fontWeightBold",
                  textAlign: "right",
                  wordBreak: "break-all",
                  color: (theme) => theme.palette.cardio.main,
                }}
              >
                {formatScore(cardio)}pt
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
export default DailySummary;
